module.exports = __webpack_public_path__ + "ed5b0ec9c74b0d87539dca54b0633c94.svg";